<template>

  <b-row>
    <b-col
        lg="4"
        md="6"
      >
        <ecommerce-goal-overview :data="this.goalOverview" />
        <ecommerce-medal :data="this.goalOverview" />
      </b-col>
    <b-col  lg="8" md="6">
      <b-card
    no-body
    class="card-company-table"
  >
      <b-table
      ref="selectableTable"
      selectable
      select-mode="single"
      :items="items"
      striped
      :fields="fields"
      responsive
      class="mb-0"
      >
        <template #cell(status_number)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
        <template #cell()="data">
            <span v-if="data.value != '0' && data.value != '1'">{{ data.value }}</span>
            <span v-if="data.value <= 1" style="color:#ddd;">{{ data.value }}</span>
        </template>
        <template #cell(attend)="data">
          <b-badge variant="primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(amount)="data">
          <span v-if="data.item.status == 'VOID'" style="color:red;"><b> -{{data.item.amount}}</b></span>
          <span v-if="data.item.status == 'ACTIVE'">{{data.item.amount}}</span>
        </template>
      </b-table>
      </b-card>


      <b-card no-body class="card-company-table" v-if="$can('read', 'admin')">
      <b-table
        ref="selectableTable"
        selectable
        select-mode="single"
        :items="complete_list"
        striped
        :fields="fields2"
        responsive
        class="mb-0"
        >
        <template #cell(rank)="data">
            <b-badge>{{ data.item.rank }} </b-badge>
        </template>
        <template #cell()="data">
            <span>{{ data.value }}</span>
        </template>
        <template #cell(series)="data">
            <span>{{ (data.item.total_price / data.item.goal * 100).toFixed(1) }}% </span>
        </template>
       
      </b-table>
      </b-card>



    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard, BButton,BTable,BBadge } from 'bootstrap-vue'

import { getUserData } from '@/auth/utils'
import EcommerceMedal from './EcommerceMedal.vue'
import EcommerceStatistics from './EcommerceStatistics.vue'
import EcommerceRevenueReport from './EcommerceRevenueReport.vue'
import EcommerceOrderChart from './EcommerceOrderChart.vue'
import EcommerceProfitChart from './EcommerceProfitChart.vue'
import EcommerceEarningsChart from './EcommerceEarningsChart.vue'
import EcommerceCompanyTable from './EcommerceCompanyTable.vue'
import EcommerceMeetup from './EcommerceMeetup.vue'
import EcommerceBrowserStates from './EcommerceBrowserStates.vue'
import EcommerceGoalOverview from './EcommerceGoalOverview.vue'
import EcommerceTransactions from './EcommerceTransactions.vue'
import moment from 'moment'

export default {
  components: {
    BRow,
    BBadge,
    BTable,
    BCol,
    Keypress: () => import('vue-keypress'),
    BButton,
    BCard,
    EcommerceMedal,
    EcommerceGoalOverview,
  },
  data() {
    return {
      data: {},
      complete_list:[],
      rangeDate:null,
      teacher_id:JSON.parse(localStorage.getItem('userData')).id,
      fields: [
          { key: 'code', label: 'Transaction Code' },
          { key: 'lesson_paid', label: 'Package' },
          { key: 'created_at', label: 'Date Time' },
          { key: 'is_newjoiner', label: 'New Join'},
          { key: 'price', label: 'Amount'}
        ],
        fields2: [
          { key: 'rank', label: 'Rank' },
          { key: 'center', label: 'Center' },
          { key: 'format_total_price', label: 'Completed' },
          { key: 'format_goal', label: 'Goal' },
          { key: 'series', label: 'Series' },
         
        ],
        /* eslint-disable global-require */
        items: [],
      centerId: 0,
      stats: {},
      centerName: '',
      devices: {},
      key_press_enabled : true,
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  watch: {
      teacher_id: {
        handler(newValue, oldValue) {
          this.get_data()
        },
      },
  },
  computed :{
    last_person() {
      return this.$store.getters['center/last_person']
    },
  },
  methods: {
    get_data() {
        this.stats = null
        this.items = []
        if (this.rangeDate === null) {
          this.rangeDate = moment().format('YYYY-MM')
        }
        this.$http.get(process.env.VUE_APP_API_BASE+`/report/user-commission/?center_id=`+ this.centerId +`&limit=10&user_id=` + this.teacher_id +`&date=`+this.rangeDate)
          .then(res => {
            this.items = res.data.transactions
            this.stats = res.data.stats
            this.goalOverview = res.data.goal
            this.complete_list = res.data.complete_list
          })
      },
    

   
  },
  created() {
    this.$http.defaults.headers.Token = this.userData.token
    this.centerId = this.$store.getters['center/currentCenterId']
    this.centerName = this.$store.getters['center/currentCenterName']
    this.get_data()
//    console.log(process.env.VUE_APP_API_BASE)
    // data
    this.$http.get('/ecommerce/data')
      .then(response => {
        this.data = response.data

        // ? Your API will return name of logged in user or you might just directly get name of logged in user
        // ? This is just for demo purpose
        const userData = getUserData()
        this.data.congratulations.name = userData.fullName.split(' ')[0] || userData.username
      })
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
